import type { Rectangle } from "./Rectangle"

export type RectangularCuboid<T> = Readonly<
  {
    depth: T
  } & Rectangle<T>
>
